<script>
import { mapGetters, mapActions } from 'vuex'
import { TYPES as CUSTOMER_ORG_TYPES } from './store'
import OrganizationCommonFiltersMixin from '../../../components/organization/mixins/OrganizationCommonFiltersMixin'

export default {
  name: 'CustomerOrganizationCommonFilters',
  mixins: [OrganizationCommonFiltersMixin],
  computed: {
    ...mapGetters({
      filters: CUSTOMER_ORG_TYPES.GENERIC.organization.customerorganization.LIST.GETTERS.filters
    })
  },
  methods: {
    ...mapActions({
      ...CUSTOMER_ORG_TYPES.GENERIC.organization.customerorganization.LIST.ACTIONS
    })
  }
}
</script>
